import { useMemo, useState } from "react";

export default function CanonicalAttendanceSelector({ label, value, onChange, options, placeholder="Search and select", disabled=false }) {
  const [query,setQuery]=useState("");
  const filtered=useMemo(()=>{const needle=query.trim().toLowerCase();return needle?options.filter(item=>item.label.toLowerCase().includes(needle)):options;},[options,query]);
  const emptyLabel=options.find(item=>item.value==="")?.label||"Select";
  return <label className="min-w-0 text-sm font-medium">{label}
    <input aria-label={`${label} search`} className="mt-1 min-h-11 w-full min-w-0 rounded-t-lg border bg-white px-3 py-2" placeholder={placeholder} value={query} onChange={event=>setQuery(event.target.value)} disabled={disabled}/>
    <select aria-label={label} className="min-h-11 w-full min-w-0 rounded-b-lg border border-t-0 bg-white px-3 py-2" value={value||""} onChange={event=>onChange(event.target.value)} disabled={disabled}>
      <option value="">{emptyLabel}</option>{filtered.filter(item=>item.value!=="").map(item=><option key={item.value} value={item.value}>{item.label}</option>)}
    </select>
  </label>;
}
